'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreviewLabel = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PreviewLabel, _Component);

  function PreviewLabel() {
    (0, _classCallCheck3.default)(this, PreviewLabel);
    return (0, _possibleConstructorReturn3.default)(this, (PreviewLabel.__proto__ || (0, _getPrototypeOf2.default)(PreviewLabel)).apply(this, arguments));
  }

  (0, _createClass3.default)(PreviewLabel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          iconUrl = _props.iconUrl,
          name = _props.name,
          sub = _props.sub,
          children = _props.children;

      var styles = require('./PreviewLabel.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.box + ' ' + (className ? className : '') },
        iconUrl && _react2.default.createElement('img', { src: iconUrl, alt: '' }),
        _react2.default.createElement(
          'div',
          { className: styles.boxContent },
          _react2.default.createElement(
            'div',
            { className: styles.main },
            name
          ),
          sub && sub.map(function (v, i) {
            return _react2.default.createElement(
              'div',
              { key: 'sub_' + i, className: styles.sub },
              v
            );
          })
        ),
        children && _react2.default.createElement(
          'div',
          { className: styles.boxChild },
          children
        )
      );
    }
  }]);
  return PreviewLabel;
}(_react.Component), _class.propTypes = {
  submit: _react.PropTypes.object,
  className: _react.PropTypes.string,
  name: _react.PropTypes.string,
  sub: _react.PropTypes.array,
  children: _react.PropTypes.object,
  iconUrl: _react.PropTypes.string
}, _temp);
exports.default = PreviewLabel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/PreviewLabel.js
// module id = 1565
// module chunks = 0